import { Box } from "@mui/material"
import type { ColumnSort, OnChangeFn, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { Classification } from "@/graphql/codegen/graphql"
import { useProductClassificationsColumns } from "@/screens/ManageProducts/components/ProductClasses/hooks"

interface ProductClassificationsTableProps {
  data: Classification[]
  fetching: boolean
  onScroll: () => void
  tableContainerRef?: Ref<HTMLDivElement>
  onSortingChange: (updaterFn: (state: SortingState) => SortingState) => void
  sorting: ColumnSort[]
  error?: Error
}
const ProductClassificationsTable: FC<ProductClassificationsTableProps> = ({
  data,
  error,
  onScroll,
  onSortingChange,
  sorting,
  tableContainerRef,
  fetching,
}) => {
  const columns = useProductClassificationsColumns()

  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable<Classification>
        error={error}
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data,
            columns,
            state: {
              sorting,
              isLoading: fetching,
            },
            manualSorting: true,
            enableSorting: true,
            enableMultiSort: false,
            enableSortingRemoval: false,
            getCoreRowModel: getCoreRowModel(),
            onSortingChange: onSortingChange as OnChangeFn<SortingState>,
          },
        }}
        slotProps={{
          container: {
            ref: tableContainerRef,
            onScroll,
          },
          bodyRow: {
            className: "hover:bg-primary-100 cursor-pointer",
          },
        }}
        noDataMessage='No product classes found'
      />
    </Box>
  )
}

export default ProductClassificationsTable
